interface BrandLogoProps {
  className?: string;
}

/**
 * TelcoOS "Helm" brand mark — a ship's wheel: steering VOIP traffic the optimal
 * direction. Six spokes, six knob handles, hubbed center. Single-tone amber,
 * theme-aware via --mark-ink (index.css): bright amber on dark, deeper
 * amber-ink on light paper.
 */
export function BrandLogo({ className }: BrandLogoProps) {
  return (
    <svg viewBox="0 0 64 64" fill="none" role="img" aria-label="TelcoOS" className={className}>
      {/* rim */}
      <circle cx="32" cy="32" r="19" stroke="var(--mark-ink)" strokeWidth="2.6" />

      {/* outer peg segments (rim → knobs) */}
      <g stroke="var(--mark-ink)" strokeWidth="2.6" strokeLinecap="round">
        <line x1="51.00" y1="32.00" x2="58.00" y2="32.00" />
        <line x1="41.50" y1="48.45" x2="45.00" y2="54.52" />
        <line x1="22.50" y1="48.45" x2="19.00" y2="54.52" />
        <line x1="13.00" y1="32.00" x2="6.00" y2="32.00" />
        <line x1="22.50" y1="15.55" x2="19.00" y2="9.48" />
        <line x1="41.50" y1="15.55" x2="45.00" y2="9.48" />
      </g>
      {/* knob handles */}
      <g fill="var(--mark-ink)">
        <circle cx="58.00" cy="32.00" r="2.2" />
        <circle cx="45.00" cy="54.52" r="2.2" />
        <circle cx="19.00" cy="54.52" r="2.2" />
        <circle cx="6.00" cy="32.00" r="2.2" />
        <circle cx="19.00" cy="9.48" r="2.2" />
        <circle cx="45.00" cy="9.48" r="2.2" />
      </g>

      {/* inner spokes (hub → rim) */}
      <g stroke="var(--mark-ink)" strokeWidth="2.4" strokeLinecap="round">
        <line x1="39.00" y1="32.00" x2="51.00" y2="32.00" />
        <line x1="35.50" y1="38.06" x2="41.50" y2="48.45" />
        <line x1="28.50" y1="38.06" x2="22.50" y2="48.45" />
        <line x1="25.00" y1="32.00" x2="13.00" y2="32.00" />
        <line x1="28.50" y1="25.94" x2="22.50" y2="15.55" />
        <line x1="35.50" y1="25.94" x2="41.50" y2="15.55" />
      </g>

      {/* hub */}
      <circle cx="32" cy="32" r="6.5" stroke="var(--mark-ink)" strokeWidth="2" />
      <circle cx="32" cy="32" r="2.2" fill="var(--mark-ink)" />
    </svg>
  );
}
